module.exports = __webpack_public_path__ + "static/media/S1-10-Qytherk-cod10.475cd843.png";